import { React, createContext, useState} from "react";
import axios from "axios";
import applyFilters from "../utils/applyFilters";
import extractDataByFilter from "../utils/extractDataByFilter";
import initializeFilterSet from "../utils/initializeFilterSet";
import calculateScreenMetrics from "../utils/calculateScreenMetrics";
import filter_params from "../utils/filter_params";
import filter_categories from "../utils/filter_categories";
import totalFiltersSelected from "../utils/totalFiltersSelected";
import mergeFilters from "../utils/mergeFilters";
import buildEndpoint from "../utils/buildEndpoint";
import convertMapToArray from "../utils/convertMapToArray";
import parseForPieChart from "../utils/parseForPieChart";
import parseForGooglePieChart from "../utils/parseForGooglePieChart";
import filterAlreadyAdded from "../utils/filterAlreadyAdded";
import groupByValues from "../utils/groupByValues";
import returnUniqueValuesInArray  from "../utils/returnUniqueValuesInArray";
import groupDataByTwoParameters  from "../utils/groupDataByTwoParameters";
// import groupDataByGroupAndAllocation  from "../utils/groupDataByGroupAndAllocation";
// import groupDataByAllocationAndProject  from "../utils/groupDataByAllocationAndProject";
// import splitIntoIndividualCharts from "../utils/splitIntoIndividualCharts";
import { variables } from "../config_variables/variables";
import parseDatesForLineOrBarChart from "../utils/parseDatesForLineOrBarChart";
import parseFilterCategoryforBarChart from "../utils/parseFilterCategoryforBarChart";
import dummy_stockdata from "../dummy_data/stockdata";
import stageSorterMain from "../utils/stageSorterMain";
import generateCurrentTimeStamp from "../utils/generateCurrentTimeStamp";


export const DataContext = createContext({
      screenDataMap: {},
      screenDataArray: [],
      getStockData: () => {},
      summarizeByParam: () => {},
      checkContext: () => {},
      showLotsHandler: () => {},
      arrowClickHandler: () => {},
      showLotsClickHandler: () => {},
      resetApp: () => {},
      toggleSumVsAvg: () => {},
      toggleSummarizeAs: () => {},
      toggleProductType: () => {},
      toggleLandVsBuild: () => {},
      toggleMetric:  () => {},
      applyFilterItems:  () => {},
      updatefiltercategory: () => {},
      setfiltercategory: () => {},
      setMoveToLotsScreen: () => {},
      setLotrec: () => {},
      analyze_stock: () => {},
      changePage: () => {},
      toggleLiveStockSwitch: () => {},
      expandColumns: () => {},
      expandRows: () => {},
      toggleProjectFilter: () => {},
      toggleStageFilter: () => {},
      toggleGroupFilter: () => {},
      toggleAllocationFilter: () => {},
      toggleRowsExpanded: () => {},
      toggleColumnsExpanded: () => {},
      resetApplication:  () => {},
      toggleWaitForProcessing:  () => {},
      toggleStockType:  () => {},
      exportToExcel:  () => {},
      setStockDataPostFilters:  () => {},
      addToFilterArray:  () => {},
      removeLastFilter:  () => {},
      printPreview:   () => {},
      // toggleUpcomingStockSwitch: () => {},
      setPrintPreviewInd:   () => {},
      btrData: [],
      dataFetchResult: {},
      dataFetchComplete:false,
      serverError: false,
      errorMessage: "",
      filtercategory: "project",
      filteritems: [],
      showCards: false,
      cardListData: {},
      totalCountsData: {},
      cardListDataScreen3: [],
      arrawDirection : "right",
      summarizeAs: "Average",
      producttypefilter : {},
      cardClicked: false,
      moveToLotsScreen: false,
      summarySwitchIsEnabled: false,
      resetFlag: false,
      lotrec: {},
      milestoneBarChartData: {},
      chartData: {},
      showPage: 1,
      groupedChartData: [],
      upcomingStockIsEnabled: false,
      liveStockIsEnabled: true,
      individualAllocationCharts : [],
      allocationProjectChartData : [],
      setGridData: {},
      columnsExpanded: false,
      rowsExpanded: false,
      projectFilter: "",
      stageFilter: "",
      waitForProcessing: false,
      stockType: "current",
      stockDataPostFilters: [],
      filterArray: [],
      printPreviewInd: false,
      
});

function DataContextProvider({ children }) {
  console.log("inside DataContextProvider for Data");

  const [dataFetchComplete, setDataFetchComplete] = useState(false);
  const [serverError, setServerError] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [btrrecords, setBtrrecords] = useState([]);
  const [filtercategory, setfiltercategory] = useState("project");   /*  store current filter selected on UI*/
  const [filteritems, setfilteritems] = useState({});
  const [showlotsButtonClicked, setShowlotsButtonClicked] =  useState()
  const [stockdata, setStockdata] = useState(stockdata);   /*  test only*/
  const [cardListData, setCardListData] = useState({}); /*  stores card data being displayed  on UI*/
  const [totalCountsData, setTotalCountsData] = useState({}); /*  stores card data being displayed  on UI*/
  const [chartData , setChartData] = useState({}); /*  stores card data being displayed  on UI*/
  const [groupedChartData , setGroupedChartData] = useState([]); /*  stores card data being displayed  on UI*/
  const [gridData , setGridData] = useState({}); /*  stores card data being displayed  on UI*/      
  const [columnsExpanded , setColumnsExpanded] = useState(false); /*  stores card data being displayed  on UI*/      
  const [rowsExpanded , setRowsExpanded] = useState(false); /*  stores card data being displayed  on UI*/      
  const [projectFilter , setProjectFilter] = useState(""); /*  stores card data being displayed  on UI*/      
  const [stageFilter , setStageFilter] = useState(""); /*  stores card data being displayed  on UI*/      
  const [groupFilter , setGroupFilter] = useState(""); /*  stores card data being displayed  on UI*/      
  const [allocationFilter , setAllocationFilter] = useState(""); /*  stores card data being displayed  on UI*/      
  const [waitForProcessing , setWaitForProcessing] = useState(false); /* show activity loader on box grid click*/      
  
  const [liveStockIsEnabled, setliveStockIsEnabled] = useState(true);
  const toggleLiveStockSwitch = () => {  setliveStockIsEnabled(previousState => !previousState)  , refreshPage()};
//   const [upcomingStockIsEnabled, setupcomingStockIsEnabled] = useState(false);
//   const toggleUpcomingStockSwitch = () => { setupcomingStockIsEnabled(previousState => !previousState) , refreshPage() };


const [cardListDataScreen3, setCardListDataScreen3] = useState([]); /*  stores card data being displayed  on UI*/
const [pieChartData, setPieChartData] = useState([]); /*  stores pie chart data */
const [landSettlementLineChartData, setLandSettlementLineChartData] = useState({}); /*  stores pie chart data */
const [buildSettlementLineChartData, setBuildSettlementLineChartData] = useState({}); /*  stores pie chart data */
const [settlementClaimLineChartData, setSettlementClaimLineChartData] = useState({}); /*  stores pie chart data */
const [milestoneBarChartData, setMilestoneBarChartData] = useState({}); /*  stores pie chart data */

const [individualAllocationCharts, setIndividualAllocationCharts] = useState([]); /*  stores pie chart data */
const [allocationProjectChartData, setAllocationProjectChartData] = useState([]); /*  stores pie chart data */

const [showCards, setShowCards] = useState(false);/*  prevents rendering of app twice on reload*/
const [currentTranche, setCurrentTranche] = useState(); /* display total records filtered after each click*/
const [producttypefilter, setProducttypefilter] = useState(variables.DEFAULT_PRODUCT_TYPE_FILTER);
const [landVsbuild, setLandVsbuild] = useState({land: true,build: true});
const [screen1Data, setScreen1Data] = useState([]); /*  store BTR Summary Data*/  
const [summarizeAs, setSummarizeAs] = useState("Average"); /*  avg or total numbers */
const [currentMetric, setCurrentMetric] = useState("Price"); /*  Price, Valuation, Size */
const [cardClicked, setCardClicked] = useState(false); /* Prevent infinite loop */
const [moveToLotsScreen, setMoveToLotsScreen] = useState(false); 
const [summarySwitchIsEnabled, setsummarySwitchIsEnabled] = useState(false);
const [resetFlag, setResetFlag] = useState(false);
const [lotrec, setLotrec] = useState(false);
const[showPage, setShowPage] = useState(1);
const [stockType, setStockType] = useState("current");
const [currentStock, setCurrentStock] = useState("current");
const [upcomingStock, setUpcomingStock] = useState("current");
const [stockDataPostFilters, setStockDataPostFilters] = useState([]);
const [filterArray, setFilterArray] = useState([]);
const [printPreviewInd, setPrintPreviewInd] = useState(false);


const filter_set = initializeFilterSet(filter_params);
  const final_filter_set =
    Object.keys(filteritems).length === 0
      ? { ...filter_set }
      : { ...filteritems };


const refreshPage = () => {
      console.log('inside refreshPage')
      setTotalCountsData({})
      // setCardListData({});
      setProjectFilter("")
      setStageFilter("")
      setGroupFilter("")
      setAllocationFilter("")
      setChartData({})
      setRowsExpanded(false)
      setColumnsExpanded(false)
	// setGroupedChartData({})
      // setTotalCountsData({})
      console.log(' BEFORE ANALYZE STOCK TotalCountsData: ' + JSON.stringify(totalCountsData))
      analyze_stock()
}

const changePage = () => {
      console.log('inside changePage | showPage : ' + showPage)
      setShowPage(showPage == 1 ?  2 : 1)
}


function expandRows() {
      console.log('inside expandRows | rowsExpanded BEFORE STATE UPDATE: ' + rowsExpanded)
      setRowsExpanded(previousState => !previousState)
      if(rowsExpanded) {
            checkColumns('project')
      } else {
            checkColumns('stage')
      }

}

function checkColumns(row) {
      if(columnsExpanded) {
            summarizeByParams(row, 'allocation')
      } else {
            summarizeByParams(row, 'group')
      }
}


function expandColumns() {
      console.log('inside expandColumns |  | columnsExpanded BEFORE STATE UPDATE: ' + columnsExpanded)
      setColumnsExpanded(previousState => !previousState)
      if(columnsExpanded) {
            checkRows('group')
      } else {
            checkRows('allocation')
      }
}

function checkRows(col) {
      if(rowsExpanded) {
            summarizeByParams('stage', col)
      } else {
            summarizeByParams('project', col)
      }
}


/* get stock*/
  async function getStockData() {
      console.log("executing getStockData");   
      const axios_url_dynamic = buildEndpoint("inventoryManagement");
      const response_records = await axios.get(axios_url_dynamic, {
            mode: "no-cors",
            headers: {
            "Access-Control-Allow-Origin": "*",
            "Content-Type": "application/json",
            },
      });
      console.log('current stock : ' +response_records.data.titleandsettlementdata.length + ' | upcoming stock : ' +response_records.data.upcoming_stock.length);
      console.log("response_records.data: " + JSON.stringify(response_records.data));

      setCurrentStock(response_records.data.titleandsettlementdata)
      setUpcomingStock(response_records.data.upcoming_stock)

      // THIS FIELD HAS TALISEN DATA - DO NOT DELETE UNTIL DEPLOYMENT
      //const btr_records = {...dummy_stockdata}
      
      if (response_records.data.statuscode === 200) {
            setStockdata(variables.isTest ? 
                  //  btr_records.data.stockdata.filter(p => ( p.Project__c != null && p.Project__r.ActiveforReporting__c &&  !p.Project__r.Name.includes('Test') && (p.StatusDEV__c == 'Available' || p.StatusDEV__c == 'Withheld')))
                  response_records.data.titleandsettlementdata.filter(p => ( p.Project__c != null && p.Project__r.ActiveforReporting__c &&  !p.Project__r.Name.includes('Test') && (p.StatusDEV__c == 'Available' || p.StatusDEV__c == 'Withheld')))
                   :
                   response_records.data.titleandsettlementdata.filter(p => ( p.Project__c != null && p.Project__r.ActiveforReporting__c &&  !p.Project__r.Name.includes('Test') && (p.StatusDEV__c == 'Available' || p.StatusDEV__c == 'Withheld'))))
            //  setBtrrecords(variables.isTest ? btr_records.data.stockdata : response_records.data.titleandsettlementdata);
            setBtrrecords(variables.isTest ? response_records.data.titleandsettlementdata : response_records.data.titleandsettlementdata);
          }
      setDataFetchComplete(true);

}


//     if (btr_records.data.statuscode === 200) {
//       setDataFetchComplete(true);
//       setStockdata(btr_records.data.stockdata.filter(p => ( p.Project__c != null && p.Project__r.ActiveforReporting__c &&  !p.Project__r.Name.includes('Test') && (p.StatusDEV__c == 'Available' || p.StatusDEV__c == 'Withheld'))));
//       setBtrrecords(btr_records.data.stockdata);
//     } else {
//       setDataFetchComplete(true);
//       setServerError(true);
//       setErrorMessage(btr_records.data.message);
//     }
//   }

 /* *initiate analysis */
 const analyze_stock = () => {      
      console.log('inside analyze_stock')
      summarizeByParam('project')      
      summarizeByParam('stage')
      summarizeByParam('lot')
      summarizeByParam('allocation')
      // summarizeByParams(rowsExpanded ? 'project': 'stage', columnsExpanded ? 'allocation' : 'group')
      summarizeByParams( rowsExpanded ? 'stage'  : 'project', columnsExpanded ? 'allocation' : 'group')
      // summarizeByParams( 'project', columnsExpanded ? 'allocation' : 'group')
 }

  const summarizeByParam = (fc) => {
    console.log("inside summarizeByParam | fc : " + fc);
    setfiltercategory(fc);
    const filter_set_init = initializeFilterSet(filter_params);
    const final_filter_items = mergeFilters(filter_params, filter_set_init, filteritems,filter_set);
//     console.log('final_filter_items: ' + JSON.stringify(final_filter_items))
    setfilteritems(final_filter_items);
    console.log('stockdata.length : ' + stockdata.length)
    const stockdata_after_filters = applyFilters(stockdata,filter_params,final_filter_items, totalFiltersSelected(final_filter_set));
    console.log('stockdata_after_filters.length :  ' + stockdata_after_filters.length)
    const stockdata_after_status_toggles = stockdata_after_filters.filter( s => {     
      // let x = ( liveStockIsEnabled ?  s.ProductAllocatedTo__c != "Upcoming" ? true : false  : false) ||  (!liveStockIsEnabled  ?  s.ProductAllocatedTo__c == "Upcoming"  ? true : false : false )
      let x = ( liveStockIsEnabled ?  s.ProductAllocatedTo__c != "Upcoming" ? true : false  : false) ||  (!liveStockIsEnabled  ?  s.ProductAllocatedTo__c == "Upcoming"  ? true : false : false )
      // console.log('s.ProductAllocatedTo__c : ' + s.ProductAllocatedTo__c + ' | liveStockIsEnabled: ' + liveStockIsEnabled + '  upcomingStockIsEnabled : ' + upcomingStockIsEnabled + ' | x: ' + x )
      // return x
      return true
     })
      console.log('stockdata_after_status_toggles.length: ' + stockdata_after_status_toggles.length + ' | liveStockIsEnabled : ' + liveStockIsEnabled)
      console.log('stockdata_after_status_toggles: ' + JSON.stringify(stockdata_after_status_toggles) )
      // const stockdata_after_applying_project_filter = stockdata_after_status_toggles.filter( s => ( s.Project__r != null && s.Project__r.Name != projectFilter ? true : false))
      
      const stockdata_after_applying_project_filter = projectFilter != "" ?  stockdata_after_status_toggles.filter( s => ( s.Project__r.Name == projectFilter ? true : false)) : [...stockdata_after_status_toggles]
      console.log('stockdata_after_applying_project_filter.length: ' + stockdata_after_applying_project_filter.length )
      const stockdata_after_applying_stage_filter = stageFilter != "" ?  stockdata_after_applying_project_filter.filter( s => ( s.Stage__r.Name == stageFilter ? true : false)) : [...stockdata_after_applying_project_filter]
      console.log('stockdata_after_applying_stage_filter.length: ' + stockdata_after_applying_stage_filter.length )
      const stockdata_after_applying_group_filter = groupFilter != "" ?  stockdata_after_applying_stage_filter.filter( s => ( s.AllocationGroup__c == groupFilter ? true : false)) : [...stockdata_after_applying_stage_filter]
      console.log('stockdata_after_applying_group_filter.length: ' + stockdata_after_applying_group_filter.length )
      const stockdata_after_applying_allocation_filter = allocationFilter != "" ?  stockdata_after_applying_group_filter.filter( s => ( s.ProductAllocatedTo__c == allocationFilter ? true : false)) : [...stockdata_after_applying_group_filter]
      console.log('stockdata_after_applying_group_filter.length: ' + stockdata_after_applying_allocation_filter.length )
      setStockDataPostFilters(stockdata_after_applying_allocation_filter)

      // console.log('stockdata_after_applying_project_filter: ' + JSON.stringify(stockdata_after_applying_project_filter) )

      // const initial_card_data = extractDataByFilter(stockdata_after_status_toggles,filter_params[fc],fc, producttypefilter);
      // const initial_card_data = extractDataByFilter(stockdata_after_applying_project_filter,filter_params[fc],fc, producttypefilter);
      // const initial_card_data = extractDataByFilter(stockdata_after_applying_stage_filter,filter_params[fc],fc, producttypefilter);
      const initial_card_data = extractDataByFilter(stockdata_after_applying_allocation_filter,filter_params[fc],fc, producttypefilter);

      cardListData[fc] = [...initial_card_data]
      totalCountsData[fc] = initial_card_data.length
      console.log("initial_card_data: " + JSON.stringify(initial_card_data) + ' | \n\n\n cardListData: ' + JSON.stringify(cardListData));

      setTotalCountsData(totalCountsData)
      setCardListData(cardListData);

      // const initial_card_data_screen3 = extractDataByFilter(stockdata_after_filters,filter_params['lot'],'lot', producttypefilter);
      // const initial_card_data_screen3 = extractDataByFilter(stockdata_after_applying_project_filter,filter_params['lot'],'lot', producttypefilter);
      // const initial_card_data_screen3 = extractDataByFilter(stockdata_after_applying_stage_filter,filter_params['lot'],'lot', producttypefilter);
      const initial_card_data_screen3 = extractDataByFilter(stockdata_after_applying_allocation_filter,filter_params['lot'],'lot', producttypefilter);
      console.log("initial_card_data_screen3: " + JSON.stringify(initial_card_data_screen3));
      setCardListDataScreen3(initial_card_data_screen3);
  };


  const summarizeByParams = (fc1, fc2) => {
    console.log("inside summarizeByParams | fc1 : " + fc1 + '  | fc2 : ' + fc2 + ' | rowsExpanded: ' + rowsExpanded + ' | columnsExpanded : ' + columnsExpanded);
    const filter_set_init = initializeFilterSet(filter_params);
    const final_filter_items = mergeFilters(filter_params, filter_set_init, filteritems,filter_set);
    setfilteritems(final_filter_items);
    const stockdata_after_filters = applyFilters(stockdata,filter_params,final_filter_items, totalFiltersSelected(final_filter_set));
    const stockdata_after_status_toggles = stockdata_after_filters.filter( s => {     
      // let x = ( liveStockIsEnabled ?  s.ProductAllocatedTo__c != "Upcoming" ? true : false  : false) ||  (!liveStockIsEnabled  ?  s.ProductAllocatedTo__c == "Upcoming"  ? true : false : false )
      // return x
      return true
     })
     console.log('projectFilter : ' + projectFilter)
      const stockdata_after_applying_project_filter = projectFilter != "" ? stockdata_after_status_toggles.filter( s => ( s.Project__r.Name == projectFilter ? true : false)) : [...stockdata_after_status_toggles]
      console.log('stockdata_after_applying_project_filter: ' + JSON.stringify(stockdata_after_applying_project_filter) )
      console.log('stockdata_after_applying_project_filter.length: ' + stockdata_after_applying_project_filter.length )
      const stockdata_after_applying_stage_filter = stageFilter != "" ?  stockdata_after_applying_project_filter.filter( s => ( s.Stage__r.Name == stageFilter ? true : false)) : [...stockdata_after_applying_project_filter]
      console.log('stockdata_after_applying_stage_filter.length: ' + stockdata_after_applying_stage_filter.length )      
      const stockdata_after_applying_group_filter = groupFilter != "" ?  stockdata_after_applying_stage_filter.filter( s => ( s.AllocationGroup__c == groupFilter ? true : false)) : [...stockdata_after_applying_stage_filter]
      console.log('stockdata_after_applying_group_filter.length: ' + stockdata_after_applying_group_filter.length )      
      const stockdata_after_applying_allocation_filter = allocationFilter != "" ?  stockdata_after_applying_group_filter.filter( s => ( s.ProductAllocatedTo__c == allocationFilter ? true : false)) : [...stockdata_after_applying_group_filter]
      console.log('stockdata_after_applying_allocation_filter.length: ' + stockdata_after_applying_allocation_filter.length )      

      const fc1_full_data = extractDataByFilter(stockdata_after_applying_allocation_filter,filter_params[fc1],fc1, producttypefilter);
      const fc2_full_data = extractDataByFilter(stockdata_after_applying_allocation_filter,filter_params[fc2],fc2, producttypefilter);      
      // const fc1_full_data = extractDataByFilter(stockdata_after_applying_stage_filter,filter_params[fc1],fc1, producttypefilter);
      // const fc2_full_data = extractDataByFilter(stockdata_after_applying_stage_filter,filter_params[fc2],fc2, producttypefilter);      
      // const fc1_full_data = extractDataByFilter(stockdata_after_applying_project_filter,filter_params[fc1],fc1, producttypefilter);
      // const fc2_full_data = extractDataByFilter(stockdata_after_applying_project_filter,filter_params[fc2],fc2, producttypefilter);
      // const fc1_full_data = extractDataByFilter(stockdata_after_status_toggles,filter_params[fc1],fc1, producttypefilter);
      // const fc2_full_data = extractDataByFilter(stockdata_after_status_toggles,filter_params[fc2],fc2, producttypefilter);
      const fc1_values_array =  returnUniqueValuesInArray(fc1_full_data)
      const fc2_values_array =  returnUniqueValuesInArray(fc2_full_data)
      // const fc_group_name = fc1+fc2
      const grid_data = {}
      grid_data['griddata'] = groupDataByTwoParameters(stockdata_after_applying_allocation_filter,fc1, fc2, fc1_values_array, fc2_values_array);
      // matrixSize
      // grid_data['griddata'] = groupDataByTwoParameters(stockdata_after_applying_stage_filter,fc1, fc2, fc1_values_array, fc2_values_array);
      // grid_data['griddata'] = groupDataByTwoParameters(stockdata_after_applying_project_filter,fc1, fc2, fc1_values_array, fc2_values_array);
      // grid_data[fc_group_name] = groupDataByTwoParameters(stockdata_after_status_toggles,fc1, fc2, fc1_values_array, fc2_values_array);
      console.log("grid_data: " + JSON.stringify(grid_data));

      
      ///// STAGE NAME SORTING LOGIC STARTS HERE
            let  names_sorted_array = []
            if(grid_data != null) {
                  const names_array = grid_data.griddata.reduce((ret_val, o)  =>  { ret_val.indexOf(o.name) == -1 ? ret_val.push(o.name) : null ; return ret_val } ,[])
                  // console.log('names_array: ' + names_array  + 'dataCtx.gridData.griddata.length : ' + dataCtx.gridData.griddata.length )
                  console.log('names_array: ' + names_array)
                  // names_sorted_array = stageSorter(names_array, grid_data.griddata , "name")
                  names_sorted_array = stageSorterMain( grid_data.griddata , "name" )
            }
            console.log('names_sorted_array: ' + JSON.stringify(names_sorted_array))
            grid_data['griddata'] = []
            grid_data['griddata'] = [...names_sorted_array]
      ///// STAGE NAME SORTING LOGIC ENDS  HERE
      
      setGridData(grid_data)
  };


  function checkContext() {
    console.log("inside data context store");
  }

    /*  invoked when card is clicked*/
  const showLotsHandler = (sfid, sfname, fc_from_card) => {
    console.log("inside showLotsHandler | sfid, sfname, fc_from_card : " + sfid, sfname, fc_from_card)
     const current_tranche_filter = filteritems.tranche;
     //     console.log('show me filters BEFORE UPDATE: ' + JSON.stringify(filter_set)) //xxxxxxxx - investigate filter overwriting 
     console.log('show me filters BEFORE UPDATE: ' + JSON.stringify(filteritems))
     console.log('filtercategory : ' + filtercategory)
     //     if (filterAlreadyAdded(filter_set[filtercategory], sfname) === -1) {  //xxxxxxxx - investigate filter overwriting 
//      if (filterAlreadyAdded(filteritems[filtercategory], sfname) === -1) {  // resolve filter removal issue
     if (filterAlreadyAdded(filteritems[fc_from_card], sfname) === -1) { 
           console.log('filter added')
           let o = {};
           o["sfid"] = sfid;
           o["sfname"] = sfname;
           // filter_set[filtercategory].push(o); //xxxxxxxx - investigate filter overwriting 
           filteritems[filtercategory].push(o);
     } else {
           /* do not remove filter if show lots button is clieked*/
           //   if(showlotsButtonClicked) {
           console.log('filter removed')
           //     filter_set[filtercategory].splice(filterAlreadyAdded(filter_set[filtercategory], sfname),filterAlreadyAdded(filter_set[filtercategory], sfname)+1)  //xxxxxxxx - investigate filter overwriting 
      //      filteritems[filtercategory].splice(filterAlreadyAdded(filteritems[filtercategory], sfname),filterAlreadyAdded(filteritems[filtercategory], sfname)+1) // resolve filter removal issue
           filteritems[fc_from_card ].splice(filterAlreadyAdded(filteritems[fc_from_card], sfname),filterAlreadyAdded(filteritems[fc_from_card], sfname)+1)
           //   }
     }
            
      //     console.log('show me filters AFTER UPDATE: ' + JSON.stringify(filter_set)) //xxxxxxxx - investigate filter overwriting 
      console.log('show me filters AFTER UPDATE: ' + JSON.stringify(filteritems))
      /*
      if (fc_from_card != "tranche") {
            filter_set["tranche"] = [...current_tranche_filter]; 
      }
      //     setfilteritems(filter_set);  //xxxxxxxx - investigate filter overwriting 
      setfilteritems(filteritems);
      if (fc_from_card == "tranche") {
            console.log('inside fc_from_card == tranche check ')
            setCurrentTranche(sfname);
            setfiltercategory("project");
      } else {
            // setfiltercategory("project");
            setCardClicked(!cardClicked)
            setfiltercategory(fc_from_card);
      }
      */

      //THIS FOLLOPWING COMMAND APPLIES FILTERS STRAIGHTAWAY ON CLICK. HAS BEEN COMMENTED BECAUSE USER WANTED TO COLLECT MULTIPLE FILTERS BEFORE APPLYING THEM
      // applyFilterItems()

  };

  const applyFilterItems = () => {
//     setfilteritems(filteritems);
//     if (fc_from_card == "tranche") {
//       console.log('inside fc_from_card == tranche check ')
//       setCurrentTranche(sfname);
//       setfiltercategory("project");
//     } else {
//       // setfiltercategory("project");
      setCardClicked(!cardClicked)
      // setfiltercategory(filtercategory);
//     }
    
  }

  const showLotsClickHandler = () => {
    console.log("inside showLotsClickHandler");
//     setfiltercategory("lot");
    setMoveToLotsScreen(true)
  };



      const arrowClickHandler = (direction)  => {
            console.log("filter_categories.length: " + filter_categories.length);
            const x = filter_categories.find((f) => f.apiname === filtercategory);
            console.log("x: " + JSON.stringify(x));
            console.log("x.id: " + x.id);
            const new_index =
            direction == "right"
                  ? x.id == 6
                  ? 1
                  : [x.id + 1]
                  : x.id == 1
                  ? 6
                  : [x.id - 1];
            console.log("new_index: " + new_index);
            const y = filter_categories.find((f) => f.id == new_index).apiname;
            console.log("y: " + y);
            // setShowCards(false);
            setfiltercategory(y);
      }

      const updatefiltercategory = (fc_from_screen) => {
            console.log('ínside updatefiltercategory | fc_from_screen: ' + fc_from_screen)
            setfiltercategory(fc_from_screen)
           console.log('filtercategory : ' + filtercategory)
      }

      const toggleProjectFilter = (pf) => {
            console.log('ínside toggleProjectFilter | existing fiilter : ' + projectFilter + ' | new filter => pf : ' + pf)
            setProjectFilter(pf)
      }

      const toggleStageFilter = (pf) => {
            console.log('ínside toggleStageFilter | pf : ' + pf)
            setStageFilter(pf)
      }

      const toggleGroupFilter = (pf) => {
            console.log('ínside toggleGroupFilter | pf : ' + pf)
            setGroupFilter(pf)
      }

      const toggleAllocationFilter = (pf) => {
            console.log('ínside toggleAllocationFilter | pf : ' + pf)
            setAllocationFilter(pf)
      }
      const toggleRowsExpanded = (val) => {
            console.log('inside toggleRowsExpanded : val : ' + val)
            setRowsExpanded(val)
      }

      const toggleColumnsExpanded = (val) => {
            setColumnsExpanded(val)
      }

      const  toggleSumVsAvg = () => {
           let temp_value = summarizeAs
           console.log('value before toggle : ' + summarizeAs)
            temp_value = temp_value == "Sum" ? "Average"  : "Sum"
            setSummarizeAs(temp_value)
            setsummarySwitchIsEnabled(previousState => !previousState)
           console.log('value after toggle : ' + summarizeAs)
      }

      const  toggleProductType = (prod_type) => {
            let temp_filter = {...producttypefilter}
            temp_filter.houseandland = prod_type == variables.PRODUCT_TYPE_H_PLUS_L ? temp_filter.houseandland ? false : true : temp_filter.houseandland
            temp_filter.townhouse = prod_type == variables.PRODUCT_TYPE_TOWNHOUSE ? temp_filter.townhouse ? false : true : temp_filter.townhouse
            setProducttypefilter(temp_filter)
      }

      function toggleMetric(m) {
            setCurrentMetric(m)
      }

      const toggleStockType = () => {
            setStockType(stockType == "current" ? "upcoming" : "current")
            setStockdata(stockType == "current" ? upcomingStock : currentStock)
      }

      const resetApp = () => {
            setfilteritems([]);
            setProducttypefilter(variables.DEFAULT_PRODUCT_TYPE_FILTER)
            setfiltercategory("tranche");
            setResetFlag(!resetFlag)
            setPrintPreviewInd(false)
            setFilterArray([])
      };

      function resetApplication() {
            toggleRowsExpanded(false)
            toggleColumnsExpanded(false)
            toggleProjectFilter("")
            toggleStageFilter("")
            toggleGroupFilter("")
            toggleAllocationFilter("")
            setPrintPreviewInd(false)
            analyze_stock()
            setFilterArray([])

      }
      
      const toggleWaitForProcessing = (val) => {
            setWaitForProcessing(val)
      }

      async function  exportToExcel() {
            const axios_url_dynamic = buildEndpoint("exportToExcel")


            // const  data = JSON.stringify({
            //       "Name": "From Workbench",
            //       "data" : ''+ stockDataPostFilters+''
            // });

            console.log('stockDataPostFilters: ' + JSON.stringify())

            var myHeaders = new Headers();
            myHeaders.append("Content-Type", "application/json");
            myHeaders.append("Access-Control-Allow-Origin" , "*");

            var raw = JSON.stringify({
                  "Name": "From Workbench",
                  "Data" : stockDataPostFilters
                  // "Data" : variables.dummy_test_data_export_to_excel_function
            })

            var requestOptions = {
                  method: 'POST',
                  headers: myHeaders,
                  body: raw,
                  redirect: 'follow'
            };

            fetch( axios_url_dynamic, requestOptions)
              .then(resp => resp.blob())
              .then(blob => {
                  const file_sent_back_by_server=blob
              if(file_sent_back_by_server) {
                  console.log('file_sent_back_by_server: '+file_sent_back_by_server)
              } else {
                  console.log('Please upload a file first')
              }
              const url = window.URL.createObjectURL(file_sent_back_by_server);
              const a = document.createElement('a');
              a.style.display = 'none';
              a.href = url;
              a.download = 'data_'+generateCurrentTimeStamp()+ '.xlsx'
              document.body.appendChild(a)
              a.click();
              window.URL.revokeObjectURL(url);
              })
              .catch((error) => {
                  alert('Error: '+error)
              });
      }


      const addToFilterArray = (array_to_join) => {
            console.log('insde addToFilterArray  |  array_to_join.length : '  + array_to_join.length + ' | array_to_join : ' + JSON.stringify(array_to_join))  
            const new_filter_array = filterArray.concat(array_to_join)
            setFilterArray(new_filter_array)

            // console.log('insde addToFilterArray  |  category : '  + category + ' | value :' + value)  
            // let new_array  = []           
            // new_array = [...filterArray]
            // new_array.push({category: category , value: value})
            // setFilterArray(new_array)
      }

      const removeLastFilter = () => {
            console.log('inside removeLastFilter| length of filter array  :  ' + filterArray.length)
            if(filterArray.length > 0) {
                  if (filterArray[filterArray.length - 1].category == 'project' ){
                        toggleProjectFilter("")
                        toggleRowsExpanded(false)
                  } else if (filterArray[filterArray.length - 1].category == 'stage' ){
                        toggleStageFilter("")
                        toggleRowsExpanded(true)
                  } else if (filterArray[filterArray.length - 1].category == 'group' ){
                        toggleGroupFilter("")
                        toggleColumnsExpanded(false)
                  } else if (filterArray[filterArray.length - 1].category == 'allocation' ){
                        toggleAllocationFilter("")
                        toggleColumnsExpanded(true)
                  }
                  filterArray.splice(-1)
            }

      }

      const printPreview = () => {
            summarizeByParams('stage', 'allocation')
            setPrintPreviewInd(!printPreviewInd)
      }


  console.log("just before data-context value update");
//   console.log("btrrecords : " + JSON.stringify(btrrecords));

  const value = {
      screenDataMap: {},
      screenDataArray: screen1Data,
      getStockData: getStockData,
      summarizeByParam: summarizeByParam,
      checkContext: checkContext,
      showLotsHandler: showLotsHandler,
      arrowClickHandler: arrowClickHandler,
      showLotsClickHandler: showLotsClickHandler,
      resetApp: resetApp,
      toggleSumVsAvg: toggleSumVsAvg,
      toggleProductType: toggleProductType,
      toggleMetric: toggleMetric,
      applyFilterItems: applyFilterItems,
      updatefiltercategory: updatefiltercategory,
      setfiltercategory:setfiltercategory,
      setMoveToLotsScreen: setMoveToLotsScreen,
      setLotrec: setLotrec,
      analyze_stock: analyze_stock,
      changePage:changePage,
      toggleLiveStockSwitch: toggleLiveStockSwitch,
      expandColumns: expandColumns,
      expandRows: expandRows,
      toggleProjectFilter: toggleProjectFilter,
      toggleStageFilter: toggleStageFilter,
      toggleGroupFilter: toggleGroupFilter,
      toggleAllocationFilter: toggleAllocationFilter,
      toggleRowsExpanded: toggleRowsExpanded,
      toggleColumnsExpanded: toggleColumnsExpanded,
      resetApplication: resetApplication,
      toggleWaitForProcessing: toggleWaitForProcessing,
      toggleStockType: toggleStockType,
      exportToExcel, exportToExcel,
      addToFilterArray: addToFilterArray,
      removeLastFilter: removeLastFilter,
      printPreview: printPreview,
      // toggleUpcomingStockSwitch: toggleUpcomingStockSwitch,
      btrData: btrrecords,
      dataFetchResult: {},
      dataFetchComplete: dataFetchComplete,
      filtercategory: filtercategory,
      filteritems: filteritems,
      showCards: showCards,
      cardListData: cardListData,
      totalCountsData: totalCountsData,
      cardListDataScreen3: cardListDataScreen3,
      serverError: serverError,
      summarizeAs: summarizeAs,
      producttypefilter: producttypefilter,
      cardClicked: cardClicked,
      moveToLotsScreen: moveToLotsScreen,
      summarySwitchIsEnabled: summarySwitchIsEnabled,
      resetFlag: resetFlag,
      lotrec: lotrec,
      chartData: chartData,
      showPage: showPage,
      liveStockIsEnabled: liveStockIsEnabled,
      gridData: gridData,
      columnsExpanded: columnsExpanded,
      rowsExpanded: rowsExpanded,
      projectFilter: projectFilter,
      stageFilter: stageFilter,
      groupFilter: groupFilter,
      allocationFilter: allocationFilter,
      waitForProcessing: waitForProcessing,
      stockType: stockType,
      stockdata: stockdata,
      filterArray: filterArray,
      printPreviewInd: printPreviewInd,

  };

  return <DataContext.Provider value={value}>{children}</DataContext.Provider>;
}

export default DataContextProvider;
